<template>
  <nav aria-label="breadcrumb" class="breadcrumb-area">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><router-link to="/">HOME</router-link></li>
      <li class="breadcrumb-item active" aria-current="page">新規登録方法のご案内</li>
    </ol>
  </nav>
  <div class="container">
      <div class="top--section">
        <Entry/>
      </div>
  </div>
</template>
<script setup lang="ts">
import Entry from '@/components/Static/Entry.vue'
</script>